import React, { useState } from "react";

const TextInput = ({
  value,
  onChange,
  type = "text",
  name,
  label,
  error,
  hint,
  placeholder,
  className,
  classNameError,
  isDisabled = false,
  labelType = "upper",
  maxLength,
  autoComplete,
  required = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;
  const errorId = name ? `${name}-error` : undefined;
  const hintId = name ? `${name}-hint` : undefined;
  const describedBy = [
    error && error !== "" ? errorId : null,
    hint ? hintId : null,
  ]
    .filter(Boolean)
    .join(" ") || undefined;

  return (
    <div className="inp_block">
      {labelType === "lower" && label && <label htmlFor={name}>{label}</label>}
      <input
        id={name}
        type={inputType}
        value={value}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={isDisabled}
        autoComplete={autoComplete}
        required={required}
        aria-invalid={Boolean(error && error !== "")}
        aria-describedby={describedBy}
        className={`${className} text-input ${
          isPasswordField ? "text-input--password" : ""
        } ${error && error !== "" ? "errorborder" : ""}`}
      />
      {labelType === "upper" && label && <label>{label}</label>}
      {isPasswordField && (
        <button
          type="button"
          className="password-toggle-btn"
          onClick={() => setShowPassword((prev) => !prev)}
          aria-label={showPassword ? "Hide password" : "Show password"}
          disabled={isDisabled}
          tabIndex={0}
        >
          <i
            className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
            aria-hidden="true"
          />
        </button>
      )}
      {hint && (
        <span id={hintId} className="text-input-hint">
          {hint}
        </span>
      )}
      {error && error !== "" && (
        <span id={errorId} className={`${classNameError} text-input-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default TextInput;
